import React from 'react';
import { Route, Navigate, RouteProps } from 'react-router-dom';

type ProtectedRouteProps = RouteProps & {
  isAdmin: boolean;
  children: JSX.Element;
};

export function ProtectedRoute({ children, isAdmin }: ProtectedRouteProps) {
  // Check if user is an admin
  const isUserAdmin = isAdmin; // Replace with your logic to determine admin status

  // Redirect if not an admin
  if (!isUserAdmin) {
    return <Navigate to="/403" replace />;
  }

  // Render the protected route
  return children;
}

export default ProtectedRoute;
